<template>
    <el-dialog class="recommend-resume-dialog"  :title="getTitle()" :visible.sync="showDialog">
        <p style="color: #999;margin: -10px 20px 10px;"><i class="el-icon-my-xinxi"></i>已评估的数据不可重新安排，将被忽略</p>
        <div class="content-confirm border-radius" :key="preventKey+'a'">
            <h1 class="text-center">候选人信息</h1>
            <el-row v-if="isSingle">
                <el-col>
                    <p>
                        <span>候选人：{{ confirmInfo.name }}</span>
                        <span class="ml-20">性别：{{ getSelectMapText('WB_GENDER', confirmInfo.gender) || '-'}}</span>
                        <span class="ml-20">手机号：{{ confirmInfo.phone }}</span>
                        <span class="ml-20">邮箱：{{ confirmInfo.email }}</span>
                    </p>
                    <p class="mt-10">当前职位：{{ confirmInfo.position }}<span class="ml-20">最高学历学校：{{ confirmInfo.school }}</span><span v-if="confirmInfo.sLevel">【{{confirmInfo.sLevel}}】</span></p>
                </el-col>
            </el-row>
            <el-table v-else :data="multiConfirmInfo">
                <el-table-column label="候选人" prop="resumeForm.name" :show-overflow-tooltip="true" align="center"
                                 min-width="80"></el-table-column>
                <el-table-column label="性别" :show-overflow-tooltip="true" align="center" min-width="50">
                    <template slot-scope="scope">{{ getSelectMapText('WB_GENDER', scope.row.resumeForm.gender) || '-'}}</template>
                </el-table-column>
                <el-table-column label="手机号" prop="resumeForm.mobilePhone" :show-overflow-tooltip="true" align="center"
                                 min-width="80"></el-table-column>
                <el-table-column label="邮箱" prop="resumeForm.email" :show-overflow-tooltip="true" align="center"
                                 min-width="80"></el-table-column>
                <el-table-column label="状态" prop="name" :show-overflow-tooltip="true" align="center"
                                 min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.paymentEvaluationForm.status === null ? '未安排' : {1: '未评估', 2: '已评估'}[scope.row.paymentEvaluationForm.status]}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="positionForm.name" align="center"
                                 min-width="60">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-my-guanbi" type="text" size="small" style="color: #ff4949" @click="multiConfirmInfo.splice(scope.$index, 1)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :key="preventKey+'b'" class="form-beauty"
                   label-width="100px">
            <el-form-item label="评估人" prop="evaluatorId">
                <user-search ref="evaluator" v-model="ruleForm.evaluatorId" :cacheOptions="confirmInfo.evaluator"></user-search>
            </el-form-item>
            <el-form-item label="消息提醒">
                <el-checkbox :true-label="1" :false-label="0" v-model="ruleForm.isEmail"
                             label="邮件"></el-checkbox>
                <el-checkbox :true-label="1" :false-label="0" v-model="ruleForm.isPoPo"
                             label="泡泡"></el-checkbox>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="showDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import fetchPositionListMixin from './fetchPositionListMixin'
    import UserSearch from 'components/userSelect/searchDownList'
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'

    const FormModel = {
        evaluatorId: null,
        ids: '',
        isEmail: 1,
        isPoPo: 1
    }
    export default {
        mixins: [fetchPositionListMixin, selectMapMixin, formCommonMixin],
        data () {
            return {
                showDialog: false,
                isSingle: true,
                confirmInfo: {
                    name: '',
                    gender: '',
                    phone: '',
                    email: '',
                    position: '',
                    school: '',
                    evaluator: []
                },
                multiConfirmInfo: [],
                preventKey: 1,
                ruleForm: Object.assign({}, FormModel),
                rules: {
                    evaluatorId: {required: true, pattern: /\d+/, message: '请输入评估人', trigger: 'blur,change'}
                }
            }
        },
        methods: {
            show (data, single = true, paymentMessageList) {  // true/false:单个/多个
                this.preventKey = +new Date()
                this.isSingle = single
                this.ruleForm = Object.assign({}, FormModel)
                this.ruleForm.isEmail = (paymentMessageList.filter(item => item.type === 'email')[0] || {}).value
                this.ruleForm.isPoPo = (paymentMessageList.filter(item => item.type === 'popo')[0] || {}).value
                if (this.isSingle) {
                    this.multiConfirmInfo = [data]
                    console.log(data.paymentEvaluationForm.id)
                    this.confirmInfo = {
                        name: data.resumeForm.name,
                        gender: data.resumeForm.gender,
                        phone: data.resumeForm.mobilePhone,
                        email: data.resumeForm.email,
                        position: data.positionForm.name,
                        school: data.resumeForm.resumeMaxEducation.school,
                        sLevel: data.resumeForm.resumeMaxEducation.sLevel
                    }
                    this.ruleForm.ids = data.id
                    this.showDialog = true
                    // 单个也设置（默认）为空 - 2018-11-29，所以先注解掉，后期可以完全删除
                    // this.$nextTick(() => {
                    //     if (data.paymentEvaluationForm.id && this.$refs.evaluator) {
                    //         let nameArr = data.paymentEvaluationForm.names.split('、')
                    //         let idArr = data.paymentEvaluationForm.operators.split(',')
                    //         this.$refs.evaluator.setDefaultValue(nameArr.map((item, index) =>  {
                    //             return {
                    //                 name: item,
                    //                 id: idArr[index]
                    //             }
                    //         }), data.paymentEvaluationForm.operators)
                    //     }
                    // })
                } else {
                    this.multiConfirmInfo = data
                    this.ruleForm.ids = data.map(item => item.id).join(',')
                    this.ruleForm.evaluatorId = ''
                    this.showDialog = true
                }
            },
            getTitle () {
                return this.isSingle ? '定薪安排' : '定薪批量安排'
            },
            saveForm (boolean) {
                if (!this.isSingle && this.multiConfirmInfo.length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '请勾选数据'
                    })
                    return false
                }
                let resumePositionIdArr = [], types = [], ignoreData = [], ignoreId = []
                this.multiConfirmInfo.forEach(item => {
                    resumePositionIdArr.push(item.id)
                    if (item.paymentEvaluationForm.id && item.paymentEvaluationForm.status === 2) {
                        ignoreData.push(item.resumeForm.name)
                        ignoreId.push(item.id)
                    }
                })
                if (ignoreData.length) {
                    resumePositionIdArr = resumePositionIdArr.filter(v => !ignoreId.includes(v))
                    if(!resumePositionIdArr.length) {
                        this.$message({
                            type: 'info',
                            message: '所选记录已被评估，请重新选择'
                        })
                        return
                    }
                    this.$confirm(`${ignoreData.join('、')}的定薪评估已完成，不可再次安排，将忽略此数据`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.submitData(resumePositionIdArr, types)
                    }).catch(e => {})
                } else {
                    this.submitData(resumePositionIdArr, types)
                }
            },
            submitData (resumePositionIdArr, types) {
                console.log(this.ruleForm.isEmail, this.ruleForm.isPoPo)
                this.ruleForm.isEmail === 1 && types.push('email')
                this.ruleForm.isPoPo === 1 && types.push('popo')
                this.$axios.post('/payment/insert.api', {
                    operators: this.ruleForm.evaluatorId instanceof Array ? this.ruleForm.evaluatorId[0] : this.ruleForm.evaluatorId,
                    resumePositionIds: resumePositionIdArr.join(','),
                    messageTypes: types.join(',')
                }, {'X-showMessage': true}).then(res => {
                    this.showDialog = false
                    this.$emit('reload')
                    this.saveDefaultMessageType()
                }).catch(console.error)
            },
            saveDefaultMessageType () {
                let types = []
                types.push({type: 'email', value: Number(this.ruleForm.isEmail)})
                types.push({type: 'popo', value: Number(this.ruleForm.isPoPo)})
                this.$axios.post('/payment/changeMessage.api', {
                    dataList: JSON.stringify(types)
                }, {'X-showMessage': false}).then(res => {
                }).catch(console.error)
            }
        },
        components: {
            UserSearch
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .recommend-resume-dialog {
    .content-confirm {
        background-color : $color-primary;
        color            : white;
        margin           : 0 20px 20px;
    > h1 {
        font-size : 18px;
        padding   : 15px;
    }
    > .el-row {
        background-color : #59a0ff;
        padding          : 15px;
        border-radius    : 0 0 $border-radius $border-radius;
    }
    }
    }
</style>



// WEBPACK FOOTER //
// arrangeSalaryDialog.vue?d1f60780